var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_999_1347",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_999_1347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1833 14C11.5111 14 9.88115 13.6272 8.29344 12.8816C6.70522 12.1364 5.29874 11.1513 4.074 9.926C2.84874 8.70126 1.86356 7.29478 1.11844 5.70656C0.372815 4.11885 0 2.48889 0 0.816667C0 0.583333 0.0777777 0.388889 0.233333 0.233333C0.388889 0.0777777 0.583333 0 0.816667 0H3.96667C4.14815 0 4.31019 0.0583333 4.45278 0.175C4.59537 0.291667 4.67963 0.440741 4.70556 0.622222L5.21111 3.34444C5.23704 3.52593 5.23393 3.69107 5.20178 3.83989C5.16911 3.98922 5.09444 4.12222 4.97778 4.23889L3.09167 6.14444C3.63611 7.07778 4.32004 7.95278 5.14344 8.76944C5.96633 9.58611 6.87037 10.2926 7.85556 10.8889L9.68333 9.06111C9.8 8.94444 9.95245 8.85682 10.1407 8.79822C10.3284 8.74015 10.513 8.72407 10.6944 8.75L13.3778 9.29444C13.5593 9.33333 13.7083 9.4207 13.825 9.55656C13.9417 9.69293 14 9.85185 14 10.0333V13.1833C14 13.4167 13.9222 13.6111 13.7667 13.7667C13.6111 13.9222 13.4167 14 13.1833 14ZM2.35278 4.66667L3.63611 3.38333L3.30556 1.55556H1.575C1.63981 2.08704 1.73056 2.61204 1.84722 3.13056C1.96389 3.64907 2.13241 4.16111 2.35278 4.66667ZM9.31389 11.6278C9.81944 11.8481 10.3349 12.0231 10.8601 12.1528C11.3849 12.2824 11.913 12.3667 12.4444 12.4056V10.6944L10.6167 10.325L9.31389 11.6278Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIc);
export default __webpack_public_path__ + "static/media/phone-ic.29d5702a1a8cb15fd0ab7d747cab601c.svg";
export { ForwardRef as ReactComponent };